import { Routes, RouterModule } from '@angular/router';

import { VisualizarEditaisClinicaComponent } from './visualizar-editais-clinica/visualizar-editais-clinica.component';
import { CadastroClinicaFormComponent } from './cadastro-clinica-form/cadastro-clinica-form.component';
import { GerarRequerimentoClinicaComponent } from './gerar-requerimento-clinica/gerar-requerimento-clinica.component';
import { GerenciarClinicaComponent } from './gerenciar-clinica/gerenciar-clinica.component';
import { AnalisarCredenciamentoClinicaComponent } from './analisar-credenciamento-clinica/analisar-credenciamento-clinica.component';
import { VisualizarHistoricoAnalisesClinicaComponent } from './visualizar-historico-clinica/visualizar-historico-clinica.component';
import { VisualizarClinicaComponent } from './visualizar-clinica/visualizar-clinica.component';

import { AuthGuard } from '../shared/authentication/auth-guard';

const clinicaRoutes: Routes = [
    { path: 'visualizar-editais-clinica', component: VisualizarEditaisClinicaComponent },
    { path: 'cadastro-clinica-form', component: CadastroClinicaFormComponent },
    { path: 'gerar-requerimento-clinica', component: GerarRequerimentoClinicaComponent },
    { path: 'gerenciar-clinica', component: GerenciarClinicaComponent, canActivate: [ AuthGuard ] },
    {
        path: 'analisar-credenciamento-clinica/:idClinicaUnidade',
        component: AnalisarCredenciamentoClinicaComponent,
        canActivate: [ AuthGuard ]
    },
    {
        path: 'visualizar-historico-clinica/:idClinicaUnidade',
        component: VisualizarHistoricoAnalisesClinicaComponent,
        canActivate: [ AuthGuard ]
    },
    { path: 'visualizar-clinica/:idClinica', component: VisualizarClinicaComponent, canActivate: [ AuthGuard ] },
];

export const clinicaRouting = RouterModule.forChild(clinicaRoutes);



// WEBPACK FOOTER //
// ./src/app/components/clinica/clinica.routing.ts